'use client';

import Button from '@components/Button';
import MeshContainer from '@components/MeshContainer';
import RawHtml from '@components/RawHtml';
import cookie from 'cookie';
import { useEffect, useId, useState } from 'react';

const COOKIE_NAME = 'youtube';
const COOKIE_VALUE = 'allowed';

type Props = {
  title: string;
  youtube_embed_code: string;
  variant: 'default' | 'orange';
};

function YouTube(props: Props) {
  const { title, youtube_embed_code, variant } = props;
  const id = useId();

  const [youtubeAccepted, setYouTubeAccepted] = useState(false);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setYouTubeAccepted(Boolean(document?.cookie?.includes(`${COOKIE_NAME}=${COOKIE_VALUE}`)));
  }, []);

  return (
    <MeshContainer variant={variant}>
      <div className='streamfield youtube'>
        <h2 className='youtube__title'>{title}</h2>
        {youtubeAccepted ? (
          <RawHtml html={youtube_embed_code} />
        ) : (
          <div className='youtube__placeholder'>
            <p id={`${id}-youtube-consent`} className='youtube__placeholder-text'>
              Mit dem Klick auf den folgenden Button stimmen Sie zu, dass Videos von Youtube geladen werden dürfen. Sie
              finden Informationen hierzu in unserer Datenschutzerklärung.
            </p>
            <Button
              primary={variant === 'default'}
              tertiary={variant === 'orange'}
              onClick={() => {
                setYouTubeAccepted(true);
                document.cookie = cookie.serialize(COOKIE_NAME, COOKIE_VALUE);
              }}
              aria-describedby={`${id}-youtube-consent`}
            >
              YouTube aktivieren
            </Button>
          </div>
        )}
      </div>
    </MeshContainer>
  );
}

export default YouTube;
